(function() {
	'use strict';

	angular
		.module('qbePortal')
		.controller('paymentRefNumController', paymentRefNumController);

	paymentRefNumController.$inject = [
		'$rootScope',
		'$scope',
		'$q',
		'$sce',
		'$window',
		'$http',
		'guideWireService',
		'labelService',
		'storage',
		'Util',
		'gtmService',
	];
	function paymentRefNumController(
		$rootScope,
		$scope,
		$q,
		$sce,
		$window,
		$http,
		guideWireService,
		labelService,
		storage,
		util,
		gtmService
	) {
		var vm = this;
		vm.findYourBill = findYourBill;
		vm.imageTooltipPath = labelService.getObjectValue(
			'enterPaymentRef',
			'img'
		);
		activate();

		function activate() {
			var autoTrigger = storage.getItem('auto-find-bill');
			if (autoTrigger && autoTrigger.trigger) {
				searchForRefNum();
				storage.removeItem('auto-find-bill');
			}
		}

		$scope.$on('reset-defaults', function(event) {
			vm.showPaymentSection = false;
		});

		vm.getObjectValue = function(fieldName, fieldLabel) {
			return $sce.trustAsHtml(
				labelService.getObjectValue(fieldName, fieldLabel)
			);
		};

		vm.getImagePath = function(fieldName, fieldLabel) {
			var path = labelService.getObjectValue(fieldName, fieldLabel);
			return path;
		};

		function isUndefinedOrNull(arg) {
			if (angular.isUndefined(arg) || arg == null) {
				return true;
			}
			return false;
		}

		function findYourBill() {
			vm.validRef = true;
			vm.paymentFlag = true;

			validatePaymentRefNum();
			if (
				checkProductIfInGuidewire() &&
				vm.validationSelector.enterPaymentRef.$valid
			) {
				searchForRefNum();
			}
		}

		function validatePaymentRefNum() {
			if (
				!isUndefinedOrNull(
					vm.validationSelector.enterPaymentRef.$$rawModelValue
				)
			) {
				//clear errors and hide validation message
				//$rootScope.$broadcast('broadcast-no-field-errors');
				if (!isUndefinedOrNull(vm.validationSelector)) {
					vm.validationSelector.enterPaymentRef.$setValidity(
						'minlength',
						true
					);
				}

				var referenceNo =
					vm.validationSelector.enterPaymentRef.$$rawModelValue;
				var refLength = referenceNo.length;
				var refLengthIsValid = refLength <= 14 && refLength >= 8;

				if (
					vm.postBillPay != 1 &&
					referenceNo.startsWith('1000') &&
					refLength >= 14
				) {
					return;
				}

				if (!referenceNo.startsWith('1000') && refLength == 14) {
					return;
				}

				if (!refLengthIsValid) {
					vm.validationSelector.enterPaymentRef.$setValidity(
						'minlength',
						false
					);
				}
			} else {
				vm.validationSelector.enterPaymentRef.$setValidity(
					'required',
					false
				);
				vm.validationSelector.enterPaymentRef.$setValidity(
					'minlength',
					true
				);
				vm.validationSelector.enterPaymentRef.$setValidity(
					'wrongref',
					true
				);
			}

			if (!vm.validationSelector.enterPaymentRef.$valid)
				$rootScope.$broadcast('broadcast-field-errors');
		}

		function checkProductIfInGuidewire() {
			var prodRefNum = vm.fieldValues.enterPaymentRef;

			if (!isUndefinedOrNull(prodRefNum)) {
				var min = prodRefNum.substr(1, 2);

				//Turn Off Claims Payment and redirect to Billpay site
				if (
					vm.postBillPay != 1 &&
					prodRefNum.startsWith('1000') &&
					prodRefNum.length == 14
				) {
					$window.open('http://billpay.qbe.com.au', '_blank');
					window.location.href = 'https://qbe.com.au';
					return false;
				} else if (
					!prodRefNum.startsWith('1000') &&
					prodRefNum.length == 14
				) {
					// Anubis
					// && min <= 26
					$window.open('http://billpay.qbe.com.au', '_blank');
					window.location.href = 'https://qbe.com.au';
					return false;
				} else if (prodRefNum.length < 8) {
					vm.validationSelector.enterPaymentRef.$setValidity(
						'wrongref',
						true
					);
				}

				if (
					prodRefNum.startsWith('1000') ||
					prodRefNum.startsWith('5000')
				) {
					if (prodRefNum.startsWith('1000')) {
						vm.policyCategory = 'claim';
					} else if (prodRefNum.startsWith('5000')) {
						vm.policyCategory = 'policy';
					}
				}
			}

			return true;
		}

		function searchForRefNum() {
			var info = guideWireService.getPaymentInfo(
				vm.fieldValues.enterPaymentRef
			);

			info.then(function(resp) {
				searchForRefNumberSuccess(resp);
			}).catch(function(err) {				
				if (err && err.status) {
					/* gtm track api error */
					gtmService.trackApiError(err.status, 'invalid payment reference number');
				}

				vm.validationSelector.enterPaymentRef.$setValidity(
					'wrongref',
					true
				);
				$rootScope.$broadcast('invalid-payment-reference-number');
				return;
			});
		}

		function searchForRefNumberSuccess(resp) {
			if (resp.data.status == 'E') {
				/* gtm track api error */
				gtmService.trackApiError(resp.data.status, 'payment error due to status E');

				$rootScope.$broadcast('payment-error');				
				return;
			} else if (resp.data.status == 'P') {
				/* gtm track api error */
				gtmService.trackApiError(resp.data.status, 'payment already made');

				$rootScope.$broadcast('payment-already-made');
				return;
			} else {
				$rootScope.$broadcast('broadcast-no-field-errors');
			}

			vm.policyNumber = resp.data.policyNumber;
			vm.paymentType = resp.data.paymentType;
			vm.amount = resp.data.amount.toFixed(2);
			vm.showPaymentSection = true;
			var details = {
				amount: vm.amount,
				reference_number: vm.fieldValues.enterPaymentRef,
				insuranceType: vm.insuranceType,
				paymentType: vm.paymentType,
				referenceId: resp.data.referenceId
			};

			storage.setItem(
				'unauth-reference',
				util.b64EncodeUnicode(vm.fieldValues.enterPaymentRef)
			);

			/* track search ref sucess after button click */
			gtmService.trackPayBillVirtualBillFound(details.reference_number, details.referenceId);
			/* end track search ref sucess after button click */

			$rootScope.$broadcast('billUpdate', details);
			$rootScope.$broadcast('toggle-amount-due');
		}

		$scope.validNumber = function(event) {
			var key = $window.event ? event.keyCode : event.which;
			if (key === 8) {
				return true;
			} else if (key < 48 || key > 57) {
				event.preventDefault();
			} else {
				return true;
			}
		};

		vm.closeImageRefForPayment = function() {
			angular.element('#pay-img-ref').toggleClass('ng-hide');
		};
	}

	angular.module('qbePortal').component('paymentRefNum', {
		templateUrl: '/ngviews/components/qbPaymentRefNum.html',
		controller: paymentRefNumController,
		controllerAs: 'vm',
		bindings: {
			fieldKey: '@',
			validationSelector: '=',
			setHierarchy: '&',
			labelKey: '@',
			insuranceType: '@',
			ngModel: '=',
			policyCategory: '=',
			postBillPay: '=',
			validRef: '=',
			showPaymentSection: '=',
			paymentRefError: '=',
			fieldValues: '='
		}
	});
})();
